module.exports = __webpack_public_path__ + "static/media/check.7ba59f21.svg";